import { render, staticRenderFns } from "./HistoryWallet.vue?vue&type=template&id=a851ecf2&scoped=true&"
import script from "./HistoryWallet.vue?vue&type=script&lang=js&"
export * from "./HistoryWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851ecf2",
  null
  
)

export default component.exports